var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-padd",style:(_vm.style)},[_c('img',{attrs:{"src":require('@/assets/adopisoft-logo-white.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }